class VwHbsHastaliktanimtaniDTO {
    id?: number = 0;
    hastaliktanimId?: number = null;
    icdaralik?: string = "";
    icdaciklama?: string = "";
    ucretTarifetanimId?: number = null;
    ekleyenKullanici?: number = null;
    eklemeTarihi?: string = null;
    guncelleyenKullanici?: number = null;
    guncellemeTarihi?: string = null;
    iptalKullanici?: number = null;
    iptalTarihi?: string = null;
};
export default VwHbsHastaliktanimtaniDTO;